import React, { useEffect, useState } from 'react';
import clienteAxios from '../../../../config/clientAxios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import Cargando from '../../../extras/Cargando';
import { Tabs, Tab } from 'react-bootstrap';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GradoMigracion = () => {
    const [status, setStatus] = useState(undefined);
    const [datasets, setDatasets] = useState({ "datasets": [], "labels": [] });
    const grado = (id) => {
        switch (id) {
            case '1': return "Muy bajo";
            case '2': return "Bajo";
            case '3': return "Medio";
            case '4': return "Alto";
            case '5': return "Muy alto";
            default: return '';
        }
    }
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        return `Grado de Intensidad Migratoria: ${grado(tooltipItem.formattedValue)}`;
                    }
                }
            },
        }
    };
    const [key, setKey] = useState('grado');
    useEffect(() => {
        const getData = async () => {
            await clienteAxios.get(`cieg/migracion/grado_migracion/grado`, { timeout: 30000 })
                .then(response => {
                    setStatus(true);
                    setDatasets(response.data.datasets);
                }).catch(error => {
                    setStatus(false);
                    console.error(error);
                });
        }
        getData();
    }, []);
    return (
        <div className='container'>
            <Tabs
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3">
                <Tab eventKey="grado" title="Grado de Intensidad Migratoria">
                    <div className='row justify-content-md-center'>
                        {status === true ? <Bar data={datasets} options={options} /> : <Cargando />}
                    </div>
                </Tab>
            </Tabs>
            <div className='row'>
                <div className='col-lg-8' style={{ textAlign: 'left', fontSize: '12px' }}>
                    <p><strong>Fuente: </strong><i>{"CONAPO"}</i></p>
                </div>
            </div>
        </div>
    );
}
export default GradoMigracion;